module.exports = __webpack_public_path__ + "img/order_logo_sz.e448db19.png";